import { Input } from '@/components/common/input'
import { SearchIcon } from '@/components/icons/search'
import { useFixedTermMarketsSearchState } from '@/hooks/useFixedTermMarketsSearchState'
import { cn } from '@/utils/cn'
import type { ChangeEvent } from 'react'

interface FixedTermMarketsSearchInputProps {
  numberOfMarkets: number
  className?: string
}

export const FixedTermMarketsSearchInput = ({ numberOfMarkets, className }: FixedTermMarketsSearchInputProps) => {
  const { search, setSearch } = useFixedTermMarketsSearchState()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }

  return (
    <div className={cn('relative inline-flex items-center', className)}>
      <SearchIcon size={20} className="pointer-events-none absolute left-3 select-none text-body-foreground" />
      <Input
        placeholder={`Search through ${numberOfMarkets} fixed-term markets`}
        value={search}
        onChange={handleChange}
        inputMode="text"
        className="pl-10"
      />
    </div>
  )
}
